import { Skeleton, Typography } from '@recruit-robin/robin-theme/web-components';
import { Navigate, Outlet } from 'react-router-dom';

import { routes } from 'config/routes';
import { useContext } from 'react';
import { useRobinJrAppStore } from 'shared/config/useRobinJrApp';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useFeatureToggles } from 'shared/legacy/hooks/useFeatureToggles';
import { useStyles } from './RobinJrRouteGuard.styles';

export const RobinJrRouteGuard = () => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const { isFeatureToggleEnabled, isLoading: isFeatureTogglesLoading } = useFeatureToggles();
  const isRobinJrApp = useRobinJrAppStore((state) => state.isRobinJrApp);

  if (isFeatureTogglesLoading) {
    return (
      <div css={classes.loading}>
        <Skeleton variant="logo" size={96} />
        <Typography variant={(v) => v.body.short}>{dictionary.loading}...</Typography>
      </div>
    );
  }

  if (!isFeatureToggleEnabled((f) => f.ROBIN_JR_CHAT) || !isRobinJrApp) {
    useRobinJrAppStore.getState().setRobinJrApp(false);

    return <Navigate to={routes.home} />;
  }

  return <Outlet />;
};
